<script setup>
import { defineProps } from "vue"
import { useTreeStore } from '@/store/modules/trees.js';
import DepthContainer from "@/components/DepthContainer";
import TreeType from "../enums/TreeType";

const props = defineProps({
  treeType: { type: Number, required: true },
})

const store = useTreeStore();

function FilterChildren(elem) {
  store.FilterChildren(elem);
}

function IsKnowledge(column) {
  if(props.treeType == TreeType.TASKS)
    return false

  return column.meta_id == 1
}
</script>

<template>
<div class="main" v-for="(branch, treeInd) in store.Tree" :key="treeInd">
    <section v-for="(column, index) in branch.levels" :key="index" class="section-depth" :class="{'special-container': column.depth > column.totalDepth - 2, 'knowledge-container': IsKnowledge(column)}" 
      v-show="column.meta_id == store.SelectedMeta.elem_id">
      <DepthContainer :column="column" :is-knowledge="IsKnowledge(column)" :tree-type="props.treeType" @filter-children="FilterChildren($event)" />
    </section>
  </div>
</template>

<style scoped>

.main {
  display: flex;
}

.section-depth {
  padding: 5px;
  max-width: 250px;
  width: 250px;
  height: 100%;
}

.special-container {
  background-color: var(--default-overlay-color);
  margin: 0px 2px;
  border-radius: 4px;
  padding: 5px;
}

.knowledge-container {
  margin: 0px;
}

@media screen and (max-width: 765px) {

  .section-depth {
    width: 180px;
  }

}
</style>
